module.exports = __webpack_public_path__ + "static/media/main-image.b5c88c41.jpeg";